module.exports = __webpack_public_path__ + "static/img/card_01@2x.ca752a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_01@2x.png
// module id = foHm
// module chunks = 0